import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { UserListPage } from './UserListPage';
import { UserFormPage } from './UserFormPage';

/**
 * ユーザー管理（基金のみ）。
 * パスは年度ルート `/years/:year` からの相対。親で RequireAuth roles を掛け、子で画面を出し分ける。
 */
export const routes: RouteObject[] = [
  {
    path: 'admin/users',
    handle: { crumb: 'ユーザー管理' } satisfies RouteHandle,
    element: (
      <RequireAuth roles={['基金']}>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <UserListPage /> },
      { path: 'new', element: <UserFormPage />, handle: { crumb: '新規登録' } satisfies RouteHandle },
      { path: ':id', element: <UserFormPage />, handle: { crumb: '編集' } satisfies RouteHandle },
    ],
  },
];
